import { useContext } from 'react';
import SharingContext from '../context';

const useLinearGradient = ({
  x1, y1, x2, y2, firstColor, lastColor,
}) => {
  const ctx = useContext(SharingContext);
  let grd;
  if (ctx !== null) {
    grd = ctx.createLinearGradient(x1, y1, x2, y2);
    grd.addColorStop(1, firstColor);
    grd.addColorStop(0, lastColor);
  }
  return grd;
};
// radial-gradient(100% 170.45% at 0% 0%, rgba(227, 96, 36, 0.15) 0%, rgba(218, 54, 46, 0.55) 100%);

const useRadialGradient = ({
  startColor, endColor, width, scale, x, y,
}) => {
  const ctx = useContext(SharingContext);
  let grd;
  if (ctx !== null) {
    grd = ctx.createRadialGradient(0 + x, 0 + y, 0, 0 + x, 0 + y, width);
    ctx.save();
    ctx.scale(...scale);
    ctx.restore();
    grd.addColorStop(0, startColor);
    grd.addColorStop(1, endColor);
  }
  return grd;
};

export { useLinearGradient, useRadialGradient };
